define('notifications_order_promocodes.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('notifications_order_promocodes', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-view=\"Promocode.Notification\"></div>  ";
},"useData":true}, 'extensions/Tavanoteam/TT_C2C_Master_Theme/1.9.7/', 'extensions/Tavanoteam/TT_C2C_Master_Theme/1.9.7/', Handlebars);
});